import { createSlice } from '@reduxjs/toolkit';
import MultiLevelMenuItems, {
  FooterMenuItems,
  SecondaryMenuItems,
} from '../../constants/multi-level-nav-items';

const initialState = {
  multiLevelMenuItems: MultiLevelMenuItems,
  footerMenuItems: FooterMenuItems,
  secondaryMenuItems: SecondaryMenuItems,
  idAndChildrenMap: {},
  secondaryMenuActions: {
    actionId: '',
    itemId: '',
  },
  loading: false,
};

const menuItemsSlice = createSlice({
  name: 'menuItems',
  initialState,
  reducers: {
    update: (state, { payload }) => ({
      ...state,
      ...payload,
      loading: false,
    }),
    reset: () => initialState,
    setSecondaryMenuActions: (state, { payload }) => {
      state.secondaryMenuActions = {
        actionId: payload.actionId,
        itemId: payload.itemId,
      };
    },
    resetSecondaryMenuActions: (state) => {
      state.loading = false;
      state.secondaryMenuActions = initialState.secondaryMenuActions;
    },
    setLoading: (state, { payload }) => {
      state.loading = payload;
    },
  },
});

export const {
  update: updateMenuItems,
  reset: resetMenuItems,
  setSecondaryMenuActions,
  resetSecondaryMenuActions,
  setLoading,
} = menuItemsSlice.actions;

export default menuItemsSlice.reducer;
